module.exports = __webpack_public_path__ + "static/media/go-apps-icon.91806a4b.svg";